import { render, staticRenderFns } from "./BestSeller.vue?vue&type=template&id=45f6d2f5&"
import script from "./BestSeller.vue?vue&type=script&lang=js&"
export * from "./BestSeller.vue?vue&type=script&lang=js&"
import style0 from "./BestSeller.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports